import React from 'react';
import { Chip } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  root: {
    width: 100,
    textTransform: 'lowercase',
  },
  activeStatus: {
    backgroundColor: 'rgba(33, 190, 88, 0.05)',
    color: 'rgb(33, 190, 88)',
  },
  blockedStatus: {
    backgroundColor: 'rgba(207, 24, 68, 0.05)',
    color: 'rgb(207, 24, 68)',
  },
  pendingStatus: {
    backgroundColor: 'rgba(66, 133, 244, 0.05)',
    color: 'rgb(66, 133, 244)',
  },
  suspendedStatus: {
    backgroundColor: 'rgba(98, 0, 238, 0.05)',
    color: 'rgb(98, 0, 238)',
  },
  archivedStatus: {
    backgroundColor: 'rgba(158, 158, 158, 0.1)',
    color: 'rgb(97, 97, 97)',
  },
}));

const StatusChipUnits = ({ status }) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  return (
    <Chip
      id={`status_chip_${status}`}
      label={status}
      className={clsx(classes.root, classes[`${status}Status`] || classes.archivedStatus)}
    />
  );
};

export default StatusChipUnits;
